module.exports = __webpack_public_path__ + "media/images/icon-chev-down-d431a05f.svg";